import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import {useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"
import {logInFormSchema, type LogInFormValues} from "@/services/auth/auth.schema";

interface LogInFormProps {
  onSubmit: (values: LogInFormValues) => void
}

export function LogInForm({
    onSubmit: onSubmitProps,
}: LogInFormProps) {
  const form = useForm<LogInFormValues>({
    resolver: zodResolver(logInFormSchema),
  })

  function onSubmit(values: LogInFormValues) {
    onSubmitProps(values)
  }



  return (
    <div className={"flex flex-col gap-6"}>
      <Card className="overflow-hidden p-0">
        <CardContent className=" p-0 ">
            <Form {...form}>
              <form onSubmit={form.handleSubmit(onSubmit)}className="p-6 md:p-8">
            <div className="flex flex-col gap-6">
              <div className="flex flex-col items-center text-center">
                <h1 className="text-2xl font-bold">Witamy w panelu administracyjnym SLDE</h1>
                {/*<p className="text-muted-foreground text-balance">*/}
                {/*  Connectez-vous à votre compte administrateur Pauchet Santé*/}
                {/*</p>*/}
              </div>
              <FormField
                  control={form.control}
                  name="email"
                  render={({ field: {value, ...field} }) => (
                      <FormItem>
                        <FormLabel>Email</FormLabel>
                        <FormControl>
                          <Input

                              id="email"
                              type="email"
                              placeholder="m@example.com"
                              required
                              value={value ?? ""} {...field} />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                  )}
              />
              <FormField
                  control={form.control}
                  name="password"
                  render={({ field: {value, ...field} }) => (
                      <FormItem>
                        <FormLabel>Hasło</FormLabel>
                        <FormControl>
                          <Input

                              id="password"
                              type="password"
                              placeholder="************"
                              required
                              value={value ?? ""} {...field} />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                  )}
              />
              <Button type="submit" className="w-full">
                Zaloguj
              </Button>
            </div>
          </form>
            </Form>
        </CardContent>
      </Card>

    </div>
  )
}
